import { messages } from "../constants/commonMessages";

const parseStoredGroups = (storedValue) => {
  if (!storedValue) return [];

  try {
    const parsedValue = JSON.parse(storedValue);
    return Array.isArray(parsedValue) ? parsedValue : [];
  } catch {
    return [];
  }
};

export const normalizeUserGroups = (groups) => {
  if (Array.isArray(groups)) return groups;
  if (!groups) return [];

  if (typeof groups === "string") {
    try {
      const parsedGroups = JSON.parse(groups);
      if (Array.isArray(parsedGroups)) return parsedGroups;
      return parsedGroups && typeof parsedGroups === "object"
        ? [parsedGroups]
        : [];
    } catch {
      return [];
    }
  }

  return typeof groups === "object" ? [groups] : [];
};

export const getUserAccessRoles = () => {
  const storedGroups = localStorage.getItem(messages.USER_GROUPS);

  return [
    ...new Set(
      parseStoredGroups(storedGroups)
        .map((group) => group?.group_name)
        .filter((groupName) => typeof groupName === "string")
        .map((groupName) => groupName.trim())
        .filter(Boolean),
    ),
  ];
};
